import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { Reveal } from '../components/ui/Reveal';
import { SplitText } from '../components/ui/SplitText';
import { ArrowButton } from '../components/ui/ArrowButton';
import { CtaBanner } from '../components/CtaBanner';
import { posts } from '../data/posts';
import { images } from '../data/images';
import { EASE_OUT } from '../utils/motion';
export function BlogPost() {
  const {
    slug
  } = useParams();
  const post = posts.find(p => p.slug === slug);
  if (!post) {
    return <section className="bg-paper px-5 pb-32 pt-48 text-center" data-id="element-492" data-mp="36gkjcm9pos4c">
        <h1 className="text-4xl font-medium" data-id="element-493" data-mp="31h7vby73tf06">Article introuvable</h1>
        <p className="mt-4 text-muted" data-id="element-494" data-mp="31j171rwkqpf1">Cet article a peut-être été déplacé.</p>
        <ArrowButton to="/blog" className="mt-8" data-id="element-495" data-mp="14nmv73qvqnpq">
          Retour au blog
        </ArrowButton>
      </section>;
  }
  const related = posts.filter(p => p.slug !== post.slug).slice(0, 3);
  return <>
      <section className="bg-ink px-5 pb-16 pt-36 text-white sm:px-8 lg:pb-24" data-id="element-496" data-mp="117ex51qikyhw">
        <div className="mx-auto max-w-4xl" data-id="element-497" data-mp="165gffkg48tsb">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-white/65 transition-colors duration-150 hover:text-white" data-id="element-498" data-mp="s4nlb0tq80pq">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-499" data-mp="x40fy7quac2v" /> Retour au blog
          </Link>
          <p className="mt-8 text-sm text-brass" data-id="element-500" data-mp="1ktl1myednnfu">
            {post.category} · {post.readTime} de lecture
          </p>
          <h1 className="mt-4 text-[clamp(2.2rem,5vw,3.75rem)] font-medium leading-[1.06] tracking-[-0.03em]" data-id="element-501" data-mp="1owr2fqiq0mex">
            <SplitText text={post.title} data-id="element-502" data-mp="1b1f7pj4kevy0" />
          </h1>
          <div className="mt-8 flex items-center gap-3" data-id="element-503" data-mp="1g11mhx01kk8x">
            <img src={images.portrait} alt="" className="h-11 w-11 rounded-full object-cover object-top" data-id="element-504" data-mp="23s7168u8x6hn" />
            <div className="text-sm" data-id="element-505" data-mp="28j5lrkm9oqqp">
              <p className="font-medium" data-id="element-506" data-mp="28k6xlrb3xh9h">Fondatrice, L Procure Consulting</p>
              <p className="text-white/60" data-id="element-507" data-mp="2idkwwav1ybwx">Publié le {post.date}</p>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-ink px-3 sm:px-5" data-id="element-508" data-mp="2dgayw6tlkrxh">
        <motion.img initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT,
        delay: 0.2
      }} src={post.image} alt="" className="mx-auto aspect-[21/9] w-full max-w-[1400px] translate-y-16 rounded-[28px] object-cover" data-id="element-509" data-mp="28g6h8dgydr5o" />
      </div>

      <article className="bg-paper px-5 pb-24 pt-32 sm:px-8" data-id="element-510" data-mp="1ungv891fcm8k">
        <div className="mx-auto max-w-2xl" data-id="element-511" data-mp="1ppf89d0vo2rt">
          <p className="text-xl leading-relaxed text-ink/85" data-id="element-512" data-mp="1pq87zu1f5s0g">{post.excerpt}</p>
          <div className="mt-10 space-y-6 text-lg leading-[1.8] text-ink/80" data-id="element-513" data-mp="1ks6ppbbthwq1">
            {post.content.map((block, i) => block.type === 'h2' ? <h2 key={i} className="pt-6 text-2xl font-medium tracking-tight text-ink" data-id="element-514" data-mp="1bpnpz03bw080">
                  {block.text}
                </h2> : <p key={i} data-id="element-515" data-mp="3nflrhyz5o7r4">{block.text}</p>)}
          </div>

          <Reveal className="mt-16" data-id="element-516" data-mp="3rdb5decgbwlf">
            <aside className="flex flex-col gap-5 rounded-[22px] bg-white p-6 sm:flex-row sm:items-center" data-id="element-517" data-mp="92y8dbpt943">
              <img src={images.portrait} alt="" className="h-20 w-20 rounded-2xl object-cover object-top" data-id="element-518" data-mp="58fwdu81e2lz" />
              <div className="flex-1" data-id="element-519" data-mp="33q1vxq82ww11">
                <p className="font-medium" data-id="element-520" data-mp="33rd21wozyfvb">Écrit par la fondatrice de L Procure Consulting</p>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-521" data-mp="38p64qfr3crqu">
                  Consultante achats et supply chain, plus de 20 ans d’expérience en entreprise et en conseil.
                </p>
              </div>
            </aside>
          </Reveal>
        </div>
      </article>

      <section className="bg-white py-20 lg:py-28" data-id="element-522" data-mp="2ky96u6w4ruyl">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-523" data-mp="2py56xv1pj28v">
          <h2 className="text-3xl font-medium tracking-tight" data-id="element-524" data-mp="2pwaocndwrm7y">À lire aussi</h2>
          <ul className="mt-10 grid gap-8 md:grid-cols-3" data-id="element-525" data-mp="viq203qa3iqw">
            {related.map(p => <li key={p.slug} data-id="element-526" data-mp="rhcza2ihfvo7">
                <Link to={`/blog/${p.slug}`} className="group block" data-id="element-527" data-mp="re8kycbazjjt">
                  <div className="aspect-[4/3] overflow-hidden rounded-[22px]" data-id="element-528" data-mp="158hyx4luonyj">
                    <img src={p.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.05]" data-id="element-529" data-mp="10gricgwbl3yo" />
                  </div>
                  <p className="mt-4 text-sm text-muted" data-id="element-530" data-mp="1a7cg624664gj">{p.category}</p>
                  <h3 className="mt-1 text-lg font-medium leading-snug group-hover:text-brass-dark" data-id="element-531" data-mp="1a95mfgavemo0">{p.title}</h3>
                </Link>
              </li>)}
          </ul>
        </div>
      </section>

      <CtaBanner data-id="element-532" data-mp="3pxywldjeeia8" />
    </>;
}